module.exports = __webpack_public_path__ + "img/stroke-1.6502c72e.svg";